/** Login Form Component */

import React from 'react';
import { Box, PasswordInput, TextInput, Button, Stack, Text } from '@mantine/core';
import { useForm } from '../../hooks/useForm';
import { isRequired, isValidUsername, isValidPassword } from '../../utils/validators';

/**
 * Login Form Component
 */
export const LoginForm = ({ onSubmit, loading = false }) => {
  const { values, errors, handleChange, handleSubmit } = useForm(
    { username: '', password: '' },
    {
      username: { required: true, custom: (v) => !isValidUsername(v) ? 'Invalid username' : null },
      password: { required: true, minLength: 6 }
    },
    onSubmit
  );

  return (
    <form onSubmit={handleSubmit}>
      <Stack>
        <TextInput
          label="Username"
          placeholder="Enter your username"
          name="username"
          value={values.username}
          onChange={handleChange}
          error={errors.username}
          disabled={loading}
          required
        />

        <PasswordInput
          label="Password"
          placeholder="Enter your password"
          name="password"
          value={values.password}
          onChange={handleChange}
          error={errors.password}
          disabled={loading}
          required
        />

        <Button type="submit" loading={loading} fullWidth>
          Login
        </Button>
      </Stack>
    </form>
  );
};

export default LoginForm;
